export default __webpack_public_path__ + "static/media/IBMCheckboxChecked.cd169bf6.svg";